const navButtons = document.querySelectorAll('[aria-controls="nav"]');
const closeButtons = document.querySelectorAll('[data-close="nav"]');
const disclosure = document.getElementById('nav');
const focusableItems = disclosure.querySelectorAll(`
    a[href],
    button:not([disabled]),
    input:not([disabled]),
    select:not([disabled]),
    textarea:not([disabled]),
    summary,
    [tabindex]:not([tabindex="-1"])
`);

let openerButton = null;

function openNavigation() {
  scrollLock(true);
  navButtons.forEach(navButton => {
    navButton.setAttribute("aria-expanded", "true");
  })
  disclosure.classList.remove("hidden");
  disclosure.removeAttribute('aria-hidden');
  document.documentElement.dataset.navigation = "open";
  focusableItems[0]?.focus();
}

function closeNavigation() {
  navButtons.forEach(navButton => {
    navButton.setAttribute("aria-expanded", "false");
  })
  disclosure.classList.add("hidden");
  disclosure.setAttribute('aria-hidden', 'true');
  document.documentElement.dataset.navigation = "closed";
  scrollLock(false);
  openerButton?.focus();
}

function toggleNavigation(e) {
  openerButton = e.currentTarget;
  const open = !disclosure.classList.contains("hidden");
  open ? closeNavigation() : openNavigation();
}

function handleTabbing(e) {
  if (e.key !== "Tab") {
    return;
  }

  const first = focusableItems[0];
  const last = focusableItems[focusableItems.length - 1];

  if (!e.shiftKey && document.activeElement === last) {
    e.preventDefault();
    first.focus();
  }

  if (e.shiftKey && document.activeElement === first) {
    e.preventDefault();
    last.focus();
  }
}

function scrollLock(lock) {
  if(lock) {
    const scrollY = window.scrollY;
    document.body.style.setProperty('--scroll-y', `${scrollY}px`);
    document.body.dataset.scrollY = scrollY;
  } else {
    const scrollY = document.body.dataset.scrollY;
    window.scrollTo({ top: parseInt(scrollY || '0', 10), left: 0, behavior: 'instant' });
  }
}

disclosure.addEventListener('keydown', handleTabbing)

navButtons.forEach(navButton => {
  navButton.addEventListener("click", toggleNavigation);
})
closeButtons.forEach(closeButton => {
  closeButton.addEventListener('click', closeNavigation);
})
focusableItems.forEach((item) => {
  if (item.matches("a")) {
    item.addEventListener("click", closeNavigation);
  }
})

window.addEventListener("keydown", (e) => {
  if (disclosure.classList.contains("hidden")) {
    return;
  }
  console.log('esc', !disclosure.classList.contains("hidden"))
  if (e.key === "Escape") {
    closeNavigation();
  }
});